/* ==========================================================================
   Busca BENIGNO — "A Vitrine" (controlador do modal central)
   - Abre/fecha o cartão central + overlay (fade/scale)
   - Foca o campo ao abrir, fecha por X / overlay / Esc, trava o scroll
   - Os resultados ao digitar são tratados pelo <predictive-search> nativo
   ========================================================================== */
(function () {
  var panel = document.querySelector('[data-ff-panel]');
  var overlay = document.querySelector('[data-ff-overlay]');
  if (!panel || !overlay) return;

  // Reposiciona overlay + cartão como filhos diretos do <body>. O header é um
  // `sticky-header` que aplica `transform` ao rolar; um ancestral transformado
  // criaria um stacking/containing block novo e faria o `position: fixed` se
  // posicionar em relação a ele — quebrando o overlay full-screen.
  if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
  if (panel.parentNode !== document.body) document.body.appendChild(panel);

  var predictive = panel.querySelector('predictive-search');
  var input = panel.querySelector('input[type="search"]');
  var resetButton = panel.querySelector('button[type="reset"]');
  var closeButtons = panel.querySelectorAll('[data-ff-close]');
  var triggers = document.querySelectorAll('[data-ff-search-open]');
  var isOpen = false;
  var lastFocus = null;

  function openPanel() {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;

    overlay.hidden = false;
    panel.hidden = false;
    document.documentElement.classList.add('ff-search-open');

    // Dois rAF garantem um paint no estado inicial (opacity 0) antes da transição
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        panel.classList.add('is-open');
        if (input) {
          input.focus();
          // Cursor ao fim de um termo pré-preenchido
          var v = input.value;
          input.value = '';
          input.value = v;
        }
      });
    });

    triggers.forEach(function (t) {
      t.setAttribute('aria-expanded', 'true');
    });
  }

  function closePanel() {
    if (!isOpen) return;
    isOpen = false;

    overlay.classList.remove('is-open');
    panel.classList.remove('is-open');
    document.documentElement.classList.remove('ff-search-open');

    // Limpa termo e resultados do predictive search, se ativo
    if (predictive && typeof predictive.close === 'function') {
      predictive.close(true);
    }
    if (resetButton) resetButton.classList.add('hidden');

    triggers.forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });

    window.setTimeout(function () {
      overlay.hidden = true;
      panel.hidden = true;
    }, 460);

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  }

  // Gatilhos (barra desktop + ícone mobile)
  Array.prototype.forEach.call(triggers, function (trigger) {
    trigger.setAttribute('aria-expanded', 'false');
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openPanel();
    });
  });

  // Fechar: botão "X", overlay e tecla Esc
  Array.prototype.forEach.call(closeButtons, function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      closePanel();
    });
  });

  overlay.addEventListener('click', closePanel);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen) closePanel();
  });
})();
